/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *	Add Multiple Triggers
 *   
 */


 class GoCart {

    constructor(options) {

        const defaults = {
            cartModalFail: '.js-go-cart-modal-fail',
            cartModalFailClose: '.js-go-cart-modal-fail-close',
            cartModal: '.js-go-cart-modal',
            cartModalClose: '.js-go-cart-modal-close',
            cartModalContent: '.js-go-cart-modal-content',
            cartModalItems: '.go-cart-item__single',
            cartDrawer: '.js-go-cart-drawer',
            cartDrawerContent: '.js-go-cart-drawer-content',
            cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
            cartDrawerFooter: '.js-go-cart-drawer-footer',
            cartDrawerClose: '.js-go-cart-drawer-close',
            cartMiniCart: '.js-go-cart-mini-cart',
            cartMiniCartContent: '.js-go-cart-mini-cart-content',
            cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
            cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
            cartTrigger: '.js-go-cart-trigger',
            cartOverlay: '.js-go-cart-overlay',
            cartCount: '.js-go-cart-counter',
            addToCart: '.js-go-cart-add-to-cart',
            removeFromCart: '.js-go-cart-remove-from-cart',
            removeFromCartNoDot: 'js-go-cart-remove-from-cart',
            itemQuantity: '.js-go-cart-quantity',
            itemQuantityPlus: '.js-go-cart-quantity-plus',
            itemQuantityMinus: '.js-go-cart-quantity-minus',
          	rebuyContent: '.js-go-cart-rebuy',
            cartMode: 'drawer',
            drawerDirection: 'right',
            displayModal: false,
            // eslint-disable-next-line no-template-curly-in-string
            moneyFormat: '${{amount}}',
            labelAddedToCart: 'was added to your box.',
            labelCartIsEmpty: 'Your Box Is Empty',
            labelQuantity: 'Quantity:',
            labelRemove: 'Remove',
            hiddenItemTag: 'hidden-product',
          	freeShippingBar: '.cart-free-shipping span',
            shippingBarTxt : '.cart-more-shipping',
          free_shipping_threshold: 100,
        };

        this.defaults = Object.assign({}, defaults, options);

        this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
        this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
        this.cartModal = document.querySelector(this.defaults.cartModal);
        this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
        this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
        this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
        this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
        this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
        this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
        this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
        this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
        this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
        this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
        this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
        this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
        this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
        // this.cartCount = document.querySelector(this.defaults.cartCount);
        this.cartCount = document.querySelectorAll(this.defaults.cartCount);
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        this.removeFromCart = this.defaults.removeFromCart;
        this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
        this.itemQuantity = this.defaults.itemQuantity;
        this.itemQuantityPlus = this.defaults.itemQuantityPlus;
        this.itemQuantityMinus = this.defaults.itemQuantityMinus;
        this.cartMode = this.defaults.cartMode;
        this.drawerDirection = this.defaults.drawerDirection;
        this.displayModal = this.defaults.displayModal;
        this.moneyFormat = this.defaults.moneyFormat;
        this.labelAddedToCart = this.defaults.labelAddedToCart;
        this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
        this.labelQuantity = this.defaults.labelQuantity;
        this.labelRemove = this.defaults.labelRemove;
        this.hiddenItemTag = this.defaults.hiddenItemTag;
      	this.free_shipping_threshold = this.defaults.free_shipping_threshold;

        this.init();

    }

    get isDrawerMode() {
        return this.cartMode === 'drawer';
    }

    init() {

        this.fetchCart();

        if (this.isDrawerMode) {
            this.setDrawerDirection();
        }

        /*
        document.addEventListener('click', (event) => {
            if (event.target.matches(this.defaults.addToCart)) {
                event.preventDefault();
                let item = event.target;
                let form = item.parentNode;
                while ('form' !== form.tagName.toLowerCase()) {
                    form = form.parentNode;
                }
                const formID = form.getAttribute('id');
                this.addItemToCart(formID);
            }
        }, false);
        */

        if (this.addToCart) { 
            this.addToCart.forEach((item) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();
                    let form = item.parentNode;
                    while ('form' !== form.tagName.toLowerCase()) {
                        form = form.parentNode;
                    }
                    const formID = form.getAttribute('id')

                    if (item.classList.contains('js-go-cart-go-to-checkout')) {
                        this.addItemToCart(formID, true)

                        item.innerHTML = `Processing...`
                        item.setAttribute('disabled', 'disabled')
                    } else {
                        this.addItemToCart(formID)
                    }
                });
            });
        }

        this.cartTrigger.forEach((item) => {
            item.addEventListener('click', () => {
                if (this.isDrawerMode) {
                    this.openCartDrawer();
                } else {
                    this.openMiniCart();
                }
                this.openCartOverlay();
            });
        });


        this.cartOverlay.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

        if (this.isDrawerMode) {
            this.cartDrawerClose.addEventListener('click', () => {
                this.closeCartDrawer();
                this.closeCartOverlay();
            });
        }

        if (this.displayModal) {
            this.cartModalClose.forEach((item) => {
                item.addEventListener('click', () => {
                    this.closeFailModal();
                    this.closeCartModal();
                    if (this.isDrawerMode) {
                        this.closeCartDrawer();
                    } else {
                        this.closeMiniCart();
                    }
                    this.closeCartOverlay();
                });
            });
        }

        this.cartModalFailClose.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

    }

    fetchCart(callback) {
        window.fetch('/cart?view=json', {
            credentials: 'same-origin',
            method: 'GET',
        })
            .then((response) => response.text())
            .then((cart) => {  eval(cart); /*console.error(window.cart);*/ this.fetchHandler(window.cart, callback)})
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    addItemToCart(formID, directCheckout = false) {
      var isp = document.querySelectorAll('.itmes_selling_plan');

      /*
      if(isp) {
        if(document.getElementById('rc_purchase_type_autodeliver').checked) {
          for (let i = 0; i < isp.length; i++) {
            document.getElementsByClassName("itmes_selling_plan")[i].removeAttribute("disabled", "");
            document.getElementsByClassName("itmes_selling_plan")[i].setAttribute("enabled", "");
          }
        }else{
          for (let i = 0; i < isp.length; i++) {
            document.getElementsByClassName("itmes_selling_plan")[i].removeAttribute("enabled", "");
            document.getElementsByClassName("itmes_selling_plan")[i].setAttribute("disabled", "");
          }
        }
  
        if(isp.length>0){
          document.getElementById("rc_purchase_type_onetime").removeAttribute("enabled", "");
          document.getElementById("rc_purchase_type_onetime").setAttribute("disabled", "");
          document.getElementById("rc_purchase_type_autodeliver").removeAttribute("enabled", "");
          document.getElementById("rc_purchase_type_autodeliver").setAttribute("disabled", "");
        }
      } 
      */
        const form = document.querySelector(`#${formID}`);
        const formData = serialize(form, {hash: true});
      console.log(formData);
      console.log('formData');
        window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((product) => {
                if(isp && isp.length > 0){
                  document.getElementById("rc_purchase_type_onetime").removeAttribute("disabled", "");
                  document.getElementById("rc_purchase_type_onetime").setAttribute("enabled", "");
                  document.getElementById("rc_purchase_type_autodeliver").removeAttribute("disabled", "");
                  document.getElementById("rc_purchase_type_autodeliver").setAttribute("enabled", "");
                  this.tempItemUpdate(product, directCheckout)
                } else {
                  if ( directCheckout ) {
                      // "Starter" package is added, please redirect to Checkout page 
                      this.goToCheckoutHandler()
                  } else { 
                      this.addItemToCartHandler(product)
                  }
                }
            })
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

   tempItemUpdate(cart,directCheckout){
     var cc = 0;
     let item = {}
      for (let i = 0; i < cart.items.length ; i++) {
        if(cc==0 && cart.items[i].quantity>0){
          item['id'] = cart.items[i].key;
          if(document.getElementById('rc_purchase_type_autodeliver').checked) {
            item['selling_plan'] = cart.items[i].selling_plan_allocation.selling_plan.id;
          }
          item['quantity'] = cart.items[i].quantity;
          cc++;
        }
      }
      window.fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify(item),
        headers: {
            'Content-Type': 'application/json',
        },
    })
    .then((response) => response.json())
    .then(() => directCheckout ? this.goToCheckoutHandler() : this.addItemToCartHandler(cart))
    .catch((error) => {
        this.ajaxRequestFail();
        throw new Error(error);
    });
   }

    removeItem(line) {
        const quantity = 0;
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    changeItemQuantity(line, quantity) {
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    cartItemCount(cart) {
        // this.cartCount.innerHTML = cart.item_count;
        this.cartCount.forEach((item) => {
            item.innerHTML = cart.item_count;
        });
    }

	updateShippingBar(cart) {
        // console.error(cart.total_price,this.free_shipping_threshold);
        if (cart.total_price >= this.free_shipping_threshold ) {
            $(this.freeShippingBar).css('width', '100%');
            $(this.shippingBarTxt).text('FREE SHIPPING');
        } else {
            $(this.freeShippingBar).css('width', parseInt(cart.total_price / 100)*4 + "%");
            var tillFreeShipping = this.free_shipping_threshold - parseInt(cart.total_price);
            $(this.shippingBarTxt).text('Free Shipping on any order $100+ 	You\'re only $' + parseFloat(tillFreeShipping / 100) + ' away!');
        }
    }

    fetchAndOpenCart() {
        this.fetchCart(() => {
            if (this.isDrawerMode) {
                this.openCartDrawer();
            } else {
                this.openMiniCart();
            }
            this.openCartOverlay();
        });
    }

    fetchAndOpenModal(product) {
        this.fetchCart(() => {
            this.renderCartModal(product);
            this.openCartModal();
            this.openCartOverlay();
        });
    }

    fetchHandler(cart, callback) {
        this.cartItemCount(cart);
      	//this.updateShippingBar(cart);
      	window.cart = cart;
      	document.dispatchEvent(
          new CustomEvent("CartFetched",{bubbles:true,detail:cart})
        );

        if (this.isDrawerMode) {
            if (cart.item_count === 0) {
                this.renderBlankCartDrawer();
                this.cartDrawerFooter.classList.add('is-invisible');
            } else {
                this.renderDrawerCart(cart);
                this.cartDrawerFooter.classList.remove('is-invisible');
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
            }
        } else if (cart.item_count === 0) {
            this.renderBlankMiniCart();
            this.cartMiniCartFooter.classList.add('is-invisible');
        } else {
            this.renderMiniCart(cart);
            this.cartMiniCartFooter.classList.remove('is-invisible');
            if ((typeof callback) === 'function') {
                callback(cart);
            }
        }
    }

    goToCheckoutHandler() {
        this.fetchCart(() => {
          window.location.href = '/checkout'
        });
    }

    addItemToCartHandler(product) {
        return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
    }

    ajaxRequestFail() {
        this.openFailModal();
        this.openCartOverlay();
    }

    renderCartModal(product) {
        this.clearCartModal();
        let productVariant = product.variant_title;
        if (productVariant === null) {
            productVariant = '';
        } else {
            productVariant = `(${productVariant})`;
        }
        const cartSingleProduct = `
          <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
            <div class="go-cart-item__info">
              ${product.product_title.includes(this.hiddenItemTag) ? 
              `<p class="go-cart-item__title">${product.product_title} ${productVariant}</p>` : 
              `<a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a>`}
              ${this.labelAddedToCart}
            </div>
          </div>`;
        this.cartModalContent.innerHTML += cartSingleProduct;
    }

    renderDrawerCart(cart) {
      	var rebuyContent = document.querySelector('.js-go-cart-rebuy');
      	
        this.clearCartDrawer();
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if ( itemVariant === null ) {
                itemVariant = '';
            }
            if ( item.selling_plan_allocation ) {
              	let itemDiscountPercentage = item.selling_plan_allocation.selling_plan.price_adjustments[0].value;
                itemVariant += `<span class="color-slate go-cart-item__discount">Saved ${itemDiscountPercentage}%</span>`;
            }
          	var purchase_type = "";
            if ( item.selling_plan_allocation ) {
              purchase_type = `<div class="go-cart-auto-renew color-glory-dark subheader3">Auto Renew</div>`;
            } else {
              if ( ! item.product_tags.includes("no-bars") ) {
              	purchase_type = `<div class="go-cart-onetime color-sky subheader3">One-Time Purchase</div>`;
              }
            }
            var product_details="";
            if ( item.product_meta.number_of_bars ) {
              if ( item.product_tags.includes("Grass-Fed-Whey") ) {
                product_details = "Grass-Fed Whey - ";
              } else if ( item.product_tags.includes("Plant") ) {
                product_details = "Plant Based - "
              } else {
                product_details = "Mixed - ";
              }

              product_details += `${item.product_meta.package_size}`;
            }

            const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}" title="${item.product_title}">
                <div class="go-cart-item__info-wrapper">
                  <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                  <div class="go-cart-item__info">
                    ${item.product_tags.includes(this.hiddenItemTag) ? 
                    `<p class="go-cart-item__title h5">${item.product_title}</p>` : 
                    `<a href="/products/${item.handle}" class="go-cart-item__title subheader5">${item.product_title.replace(' Auto renew', '')}</a>`}
					<div class="go-cart-product-details step-value subheader3 color-slate">${product_details}</div>
					${purchase_type}
                    <div class="go-cart-item__variant body1">${itemVariant}</div>
                    <div class="go-cart-price-qty body1">
                      <div class="go-cart-item__price body1">
                        ${formatMoney(item.line_price, this.moneyFormat)}
                        ${item.original_line_price > item.line_price? `<s class="color-slate">${formatMoney(item.original_line_price, this.moneyFormat)}</s>` : ``}
                      </div>
                      <div class="go-cart-item__quantity body1">
                        ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus go-cart-quantity-minus">-</span>`}
                        <input class="go-cart-item__quantity-number js-go-cart-quantity body1" type="number" value="${item.quantity}" disabled>
                        ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus go-cart-quantity-plus">+</span>`}
                      </div>
                    </div>
                  </div>
                </div>
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}"><i class="icon-remove cart-remove"></i></a>
              </div>`;
            this.cartDrawerContent.innerHTML += cartSingleProduct;
        });
      	if (rebuyContent) {
        	this.cartDrawerContent.appendChild(rebuyContent);
        }
      	// console.error(cart.total_price,this.cartDrawerSubTotal);
        this.cartDrawerSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
    }

    renderMiniCart(cart) {
        this.clearMiniCart();
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        ${item.product_tags.includes(this.hiddenItemTag) ? 
                        `<p class="go-cart-item__title h3">${item.product_title}</p>` : 
                        `<a href="${item.url}" class="go-cart-item__title h3">${item.product_title}</a>`}
                        <div class="go-cart-item__variant">${itemVariant}</div>
                        <div class="go-cart-item__quantity">
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                          <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                        </div>
                    </div>
                </div>
                <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
              </div>`;
            this.cartMiniCartContent.innerHTML += cartSingleProduct;
        });
        this.cartMiniCartSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
    }

    renderBlankCartDrawer() {
        this.cartDrawerSubTotal.parentNode.classList.add('is-invisible');
        this.clearCartDrawer();
        this.cartDrawerContent.innerHTML = `<div class="go-cart__empty h3 color-sky">${this.labelCartIsEmpty}</div>`;
    }

    renderBlankMiniCart() {
        this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
        this.clearMiniCart();
        this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty h3 color-sky">${this.labelCartIsEmpty}</div>`;
    }

    reloadAjaxContent() {
      this.fetchAndOpenCart();
    }

    clearCartDrawer() {
        this.cartDrawerContent.innerHTML = '';
    }

    clearMiniCart() {
        this.cartMiniCartContent.innerHTML = '';
    }

    clearCartModal() {
        this.cartModalContent.innerHTML = '';
    }

    openCartDrawer() {
        this.cartDrawer.classList.add('is-open');
    }

    closeCartDrawer() {
        this.cartDrawer.classList.remove('is-open');
    }

    openMiniCart() {
        this.cartMiniCart.classList.add('is-open');
    }

    closeMiniCart() {
        this.cartMiniCart.classList.remove('is-open');
    }

    openFailModal() {
        this.cartModalFail.classList.add('is-open');
    }

    closeFailModal() {
        this.cartModalFail.classList.remove('is-open');
    }

    openCartModal() {
        this.cartModal.classList.add('is-open');
    }

    closeCartModal() {
        this.cartModal.classList.remove('is-open');
    }

    openCartOverlay() {
        this.cartOverlay.classList.add('is-open');
    }

    closeCartOverlay() {
        this.cartOverlay.classList.remove('is-open');
    }

    static removeItemAnimation(item) {
        item.classList.add('is-invisible');
    }

    setDrawerDirection() {
        this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
    }

}

//export default GoCart;

